import { Controller } from "@/js/lite-js/controller";

export class ActivityFormController extends Controller {

  get reimbursementStepCheckbox(): HTMLInputElement {
    return this.$refs.get('reimbursement-report-step') as HTMLInputElement
  }

  get reportTypeSelect(): HTMLSelectElement {
    return this.$refs.get('reimbursement-report-type') as HTMLSelectElement
  }

  get reportSurveyWrap(): HTMLDivElement {
    return this.$refs.get('reimbursement-report-survey') as HTMLDivElement
  }

  get reportSurveySelect(): HTMLSelectElement {
    // return this.$refs.get('reimbursement-report-survey') as HTMLSelectElement
    return this.reportSurveyWrap.querySelector('select') as HTMLSelectElement
  }

  get reportSurveyLabel(): HTMLLabelElement {
    // return this.$refs.get('reimbursement-report-survey-label') as HTMLLabelElement
    return this.reportSurveyWrap.querySelector('label') as HTMLLabelElement
  }

  protected valueUpdated() {
    let reportTypeDisabled = true
    let surveyDisabled = true

    if (this.reimbursementStepCheckbox.checked) {
      reportTypeDisabled = false
      const surveySelected = this.reportTypeSelect.selectedOptions.item(0)?.dataset.surveyItem == 'true'
      surveyDisabled = !surveySelected
    }

    this.reportTypeSelect.disabled = reportTypeDisabled
    this.reportSurveySelect.disabled = surveyDisabled
    if (surveyDisabled) {
      this.reportSurveyLabel.classList.remove('required')
    } else {
      this.reportSurveyLabel.classList.add('required')
    }
  }
}
